import React, { useEffect, useState } from 'react'
import { NotificationServices } from '../NotificationServices';
import { Box, CircularProgress, Step, StepContent, StepLabel, Stepper, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { formatDateTime } from '../../../../utils/dateUtils';

const NotificationLog = ({campaignId}) => {
    const [notificationLogs, setNotificationLogs] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const[fetchingLogs,setFetchingLogs] = useState(false);
    const fetchNotificationLogs = async()=>{
        setFetchingLogs(true);
        const response = await NotificationServices.fetchCampaignLogs(campaignId);
        console.log("fetchNotificationLogs response",response);
        if(response.success == '1'){
            setNotificationLogs(response.data);
        } else if(response.success == '0'){
            setNotificationLogs([]);
        }
        setFetchingLogs(false);
    }
    useEffect(() => {
        if(campaignId){
            fetchNotificationLogs();
        }
    },[campaignId])
    const CustomStepIcon = ({ active, completed }) => {
            return (
                <Box
                    sx={{
                        width: 5, // Adjust size
                        height: 5, // Adjust size
                        borderRadius: "50%",
                        backgroundColor: completed || active ? "primary.main" : "grey.400",
                    }}
                />
            );
        };
  return (
    <Box sx={{px:'2%',maxHeight:'12rem',minHeight:'7rem',overflowY:'auto'}}>
        {fetchingLogs ?
            <Box sx={{py:'5%',textAlign:'center'}}>
                <CircularProgress size={20} />
                <Typography sx={{fontSize:'0.75rem',color:'gray'}}>Loading Logs...</Typography>
            </Box>
        :
        (notificationLogs && notificationLogs.length > 0 )?
        
        <Stepper activeStep={activeStep} orientation="vertical" 
            sx={{
                '& .MuiStepConnector-root': {
                    marginLeft: '.55%',
                },
                '& .MuiStepConnector-line': {
                    minHeight:'.5rem'
                },
            }}
        >
            {notificationLogs.map((step, index) => (
                <Step key={index} expanded={true}>
                    <StepLabel StepIconComponent={CustomStepIcon} sx={{p:0}}>
                        <Typography sx={{fontSize:'0.65rem',fontWeight:500}}>Campaign 
                            <Box component={'span'} sx={{textTransform:'capitalize',ml:'1%'}}>{step.status}</Box>
                            <Box component={'span'} sx={{textTransform:'capitalize',ml:'2%',color:'lightGray'}}>{formatDateTime(step?.datetime)}</Box>
                        </Typography>
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
        :
        <Box sx={{py:'5%',textAlign:'center'}}>
            <Typography sx={{fontSize:'0.75rem',color:'gray'}}>No Logs Found</Typography>
        </Box>
        
        }
    </Box> 
  )
}

export default NotificationLog
